import { RestService } from "@sinossi/mates-react-library"
import { GeographicPermission, GeographicPermissionRequest } from "models"

export class GeographicPermissionService {
    static getPermissions = (accountId: string, callback: any, catchCallback: any) => {
        RestService
            .get<GeographicPermission[]>(`/api/account/${accountId}/geographic-permissions`)
            .then(callback)
            .catch(catchCallback)
    }

    static addPermission = (accountId: string, request: GeographicPermissionRequest, callback: any, catchCallback: any) => {
        RestService
            .post(`/api/account/${accountId}/geographic-permissions`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static removePermission = (accountId: string, permissionId: string, callback: any, catchCallback: any) => {
        RestService
            .delete(`/api/account/${accountId}/geographic-permissions/${permissionId}`)
            .then(callback)
            .catch(catchCallback)
    }
}
